(function($) {
	$('.vimeo-video').each(function() {
		var player = new Vimeo.Player(this);

	});
	
	$('.vimeo-modal').each(function() {
		var $iframe = $(this).find('.vimeo-video');
		var player = new Vimeo.Player($iframe[0]);
		
		$(this).on('shown.bs.modal', function() {
			player.play();
		}).on('hide.bs.modal', function() {
			player.pause();
		});
	});
	
}(jQuery));